import { render, staticRenderFns } from "./ActionSendInternalNotification.vue?vue&type=template&id=de1b52de"
import script from "./ActionSendInternalNotification.vue?vue&type=script&lang=js"
export * from "./ActionSendInternalNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports